require('./loginController');
require('../fhApp/cdnUrl/cdnUrl');

"use strict";

angular.module('app.login', [
  'app.login.loginController',
  'app.cdnUrl'
])
  .config([
    '$stateProvider', 'PRODUCT',
    function ($stateProvider, product) {
      
      let logTemplate = 'components/login/loginView.html';
      if (product.Code != 'htv') {
        logTemplate = 'assets/templates/' + product.Code + '/login/loginView.html';
      }

      $stateProvider.state('app.login', {
        url: '/login',
        templateUrl: logTemplate,
        controller: 'app.login.loginController',
        params: {
          error: null,
          errorType: null,
          redirect: null,
          redirectParams: null,
          autoLogin: false,
          login_name: null,
          password: null
        },
        title: 'Sign In',
        noSidebar: true,
        noTitleBar: true
      });
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/login/login.js